module.exports = __webpack_public_path__ + "static/img/give_up.42e8aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/give_up.png
// module id = gA3z
// module chunks = 0